export default __webpack_public_path__ + "fae4d925ae44452d9039e389c0f6d3ee.svg";